<template>
  <div class="app-container" v-if="form">
    <!-- 头部信息 -->
    <div class="record-info">
      <!-- 返回按钮 -->
      <div class="back-button" @click="handleBack">
        返回列表
      </div>

      <!-- 顶部信息卡片 -->
      <div class="header-section section-box">
        <div class="order-info">
          <div class="order-status">订单状态：{{ stateTxt }}</div>
          <div class="order-id">
            订单编码: {{ form.signUpNo }}
            <i class="el-icon-document"></i>
          </div>
          <div class="registration-method">报名方式: {{ getSourceText() }}</div>
         
        </div>
        <div class="registration-method">报名费用: {{ getFeeText() }}</div>
        <div class="registrant-title">报名人信息</div>
        <div class="registrant-info" v-if="form.userRealName">
          <div class="registrant-name">
            {{ form.userRealName }}
            <span class="level-name">{{ form.userLevelName }}</span>
          </div>
          <div class="registrant-details">
            <span>手机号: {{ form.userMobile }}</span>
            <span v-if="getUserRegionText()"
              >所属区域: {{ getUserRegionText() }}</span
            >
          </div>
        </div>
      </div>

      <!-- 工作流时间线 -->
      <div class="progress-section section-box">
        <div
          class="progress-item"
          :class="{ active: isStatusActive(10) }"
          v-if="form.payVouchersStatus != null && form.payVouchersStatus !== ''"
        >
          <div class="progress-dot"></div>
          <span>{{
            isStatusActive(10) && +activeName > 10 ? "审核通过" : "待审核"
          }}</span>
          <div class="progress-time">
            <div>报名时间: {{ form.createdTime || "-" }}</div>
            <div>报名方式: {{ getSourceText() }}</div>
            <div v-if="form.carryPeopleNum">
              成人票{{ getAdultCount() }}张,儿童票{{ getChildCount() }}张
            </div>
            <div>报名费用: ¥{{ form.fee || 0 }}</div>
            <div
              v-if="form.paymentMethod === 30 && hasVoucher()"
              class="payment-method-row"
            >
              线下支付
              <el-link
                type="primary"
                @click="handleViewVoucher"
                class="view-voucher-link"
                >查看凭证</el-link
              >
            </div>
            <div v-if="form.giftAccountAmount">
              赠送: {{ form.giftAccountAmount }}{{ getGiftAccountTypeText() }}
            </div>
          </div>
        </div>
        <div class="progress-item" :class="{ active: isStatusActive(99) }">
          <div class="progress-dot"></div>
          <span>{{ isStatusActive(99) ? "已开始" : "未开始" }}</span>
          <div class="progress-time">
            <div v-if="form.paymentTime">审核时间: {{ form.paymentTime }}</div>
          </div>
        </div>
        <div class="progress-item" :class="{ active: isStatusActive(20) }">
          <div class="progress-dot"></div>
          <span>{{ isStatusActive(20) ? "已参会" : "待参会" }}</span>
          <div class="progress-time">
            <div v-if="form.meetingStartTime">
              会议时间: {{ form.meetingStartTime }} ~
              {{ form.meetingEndTime }}
            </div>
          </div>
        </div>
        <div class="progress-item" :class="{ active: isStatusActive(30) }">
          <div class="progress-dot"></div>
          <span>{{form.signInTime ? '已签到' : '未签到'}}</span>
          <div class="progress-time">
            <div v-if="form.signInTime">签到时间: {{ form.signInTime }}</div>
            <div v-if="form.signInMethod">
              签到方式:
              {{ form.signInMethod === 10 ? "App签到" : "后台签到" }}
            </div>
          </div>
        </div>
        <div class="progress-item" :class="{ active: isStatusActive(22) }">
          <div class="progress-dot"></div>
          <span>已完成</span>
          <div class="progress-time">
            <div v-if="form.meetingEndTime">
              结束时间: {{ form.meetingEndTime }}
            </div>
          </div>
        </div>
        <!-- 进度线（绝对定位，不占宽度） -->
        <div
          class="progress-line progress-line-0"
          :class="{ active: isProgressLineActive(0) }"
        ></div>
        <div
          class="progress-line progress-line-1"
          :class="{ active: isProgressLineActive(1) }"
        ></div>
        <div
          class="progress-line progress-line-2"
          :class="{ active: isProgressLineActive(2) }"
        ></div>
        <div
          class="progress-line progress-line-3"
          :class="{ active: isProgressLineActive(3) }"
        ></div>
      </div>
    </div>

    <!-- 会议信息 -->
    <div
      class="meeting-section section-box"
      v-if="form.meeting"
      v-loading="meetingLoading"
    >
      <div class="section-header">
        <div class="section-title">
          <span>会议信息</span>
        </div>
      </div>
      <div class="meeting-header">
        <el-image
          class="main-image"
          :src="form.meetingImageUrl || form.meeting.imageUrl"
          :preview-src-list="[form.meetingImageUrl || form.meeting.imageUrl]"
          fit="cover"
        ></el-image>
        <div class="meeting-content">
          <div class="meeting-title-wrapper">
            <h2 class="meeting-title-text">
              {{ form.meetingTitle || form.meeting.title }}
              <span class="meeting-type-badge">
                {{ form.meeting.categoryName }}
              </span>
            </h2>
          </div>
          <div class="meeting-meta">
            <div class="meta-item" v-if="form.meeting.userRealName">
              <span class="meta-label">创建会议人:</span>
              <span class="meta-value"
                >{{ form.meeting.userRealName }}({{
                  form.meeting.userLevelName
                }}){{ form.meeting.userMobile }}</span
              >
            </div>
            <div
              class="meta-item"
              v-if="
                (form.meeting.lecturerList &&
                  form.meeting.lecturerList.length > 0) ||
                  form.meeting.lecturerRealName
              "
            >
              <span class="meta-label">主讲老师:</span>
              <span class="meta-value">
                <template
                  v-if="
                    form.meeting.lecturerList &&
                      form.meeting.lecturerList.length > 0
                  "
                >
                  <span
                    v-for="(lecturer, index) in form.meeting.lecturerList"
                    :key="index"
                  >
                    {{ lecturer.realName }}({{ lecturer.levelName }}){{
                      lecturer.mobile
                    }}<span v-if="index < form.meeting.lecturerList.length - 1"
                      >，</span
                    >
                  </span>
                </template>
                <template v-else>
                  {{ form.meeting.lecturerRealName }}({{
                    form.meeting.lecturerLevelName
                  }}){{ form.meeting.lecturerMobile }}
                </template>
              </span>
            </div>
            <div class="meta-item" v-if="form.meeting.address">
              <span class="meta-label">省市区:</span>
              <span class="meta-value">{{ form.meeting.address }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 参会人信息 -->
    <div class="participants-section section-box">
      <div class="section-header">
        <div class="section-title">
          <span>参会人信息:<span style="color: #e73f3f;font-size: 12px;margin-left: 10px;">
            温馨提示：无论是通过APP线下支付/线上支付、后台导入或后台报名等方式，费用明细仅显示于主报名显示。
          </span></span>
        
        </div>
        <div class="participants-summary" v-if="participantsList.length > 0">
          总报名{{ participantsList.length }}人, {{ getAdultCount() }}成人,
          {{ getChildCount() }}位儿童
        </div>
      </div>
      <div class="section-body" v-loading="participantsLoading">
        <div class="participants-table" v-if="participantsList.length > 0">
          <div class="table-header">
            <div class="header-cell" style="width: 30%;">参会人信息</div>
            <div class="header-cell" style="width: 100px;">费用</div>
            <div class="header-cell" style="width: 120px;">交通方式</div>
            <div class="header-cell" style="flex: 1;">住宿信息</div>
            <div class="header-cell" style="width: 120px;">刷脸信息认证</div>
            <div class="header-cell" style="width: 120px;">取消明细</div>
            <div class="header-cell" style="width: 120px;">签到明细</div>
          </div>
          <div class="table-body">
            <div
              v-for="(participant, index) in participantsList"
              :key="index"
              class="table-row"
            >
              <div class="table-cell" style="width: 30%;">
                <div class="participant-info">
                  <div class="participant-name">
                    {{ participant.realName }}
                    <span v-if="participant.relationship" class="relationship"
                      >({{ participant.relationship }})</span
                    >
                    <span class="gender">{{
                      participant.sex === 1
                        ? "男"
                        : participant.sex === 2
                        ? "女"
                        : ""
                    }}</span>
                  </div>
                  <div class="participant-id">
                    身份证号: {{ participant.idCardNo?participant.idCardNo:'-'}}
                    <span class="age-tag">{{
                      participant.isChild ? "(儿童)" : "(成人)"
                    }}</span>
                  </div>
                  <div class="participant-mobile">
                    手机号: {{participant.mobile }}
                  </div>
                </div>
              </div>
              <div class="table-cell" style="width: 100px;">
                {{participant.signUpFee }}
              </div>
              <div class="table-cell" style="width: 120px;">
                <el-link
                  type="primary"
                  @click="handleViewTransportation(participant)"
                  v-if="participant.isSubmitTransportation"
                >
                  查看交通信息
                </el-link>
              </div>
              <div class="table-cell" style="flex: 1;">
                <div class="accommodation-info">
                  <div
                    class="accommodation-item"
                    v-if="participant.rideCarNumber"
                  >
                    乘坐车辆: {{ participant.rideCarNumber }}
                  </div>
                  <div
                    class="accommodation-item"
                    v-if="participant.meetingSeatNumber"
                  >
                    会议座位号: {{ participant.meetingSeatNumber }}
                  </div>
                  <div class="accommodation-item" v-if="participant.stayHotel">
                    房间号: {{ participant.stayHotel }}
                  </div>
                  <div
                    class="accommodation-item"
                    v-if="participant.diningSeatNumber"
                  >
                    餐位号: {{ participant.diningSeatNumber }}
                  </div>
                </div>
              </div>
              <div class="table-cell" style="width: 120px;">
                <span
                  v-if="participant.isChild"
                  class="auth-status no-auth-required"
                  >无需认证</span
                >
                <span
                  v-else-if="participant.faceInfo && participant.faceInfo.certificateStatus === 1"
                  class="auth-status authenticated"
                  >已认证</span
                >
                <span
                  v-else-if="participant.faceInfo && participant.faceInfo.certificateStatus === 0"
                  class="auth-status not-authenticated"
                  >未认证</span
                >
                <span
                  v-else
                  class="auth-status not-authenticated"
                  >未认证</span
                >
              </div>
              <div class="table-cell" style="width: 120px;">
                <el-link
                  v-if="participant.cancelTime"
                  type="primary"
                  @click="handleViewCancelDetail(participant)"
                >
                  查看明细
                </el-link>
              </div>
              <div class="table-cell" style="width: 120px;">
                <span v-if="participant.signInTime">
                  {{ participant.signInTime }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="empty-data">暂无参会人信息</div>
      </div>
    </div>

    <!-- 查看凭证弹窗 -->
    <el-dialog
      title="付款凭证"
      :visible.sync="voucherDialogVisible"
      width="800px"
    >
      <div class="voucher-list" v-if="voucherList.length > 0">
        <el-image
          v-for="(item, index) in voucherList"
          :key="index"
          :src="item.payImg || item"
          :preview-src-list="voucherList.map(i => i.payImg || i)"
          style="width: 200px; height: 200px; margin: 10px;"
          fit="cover"
        ></el-image>
      </div>
      <div v-else>暂无凭证</div>
    </el-dialog>

    <!-- 交通信息弹窗 -->
    <transportation-vue ref="transportationVue" />

    <!-- 取消明细弹窗 -->
    <el-dialog
      title="取消明细"
      :visible.sync="cancelDetailVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="cancel-detail-content">
        <div class="detail-item">
          <span class="detail-label">取消类型:</span>
          <span class="detail-value">{{
            getCancelTypeText(
              currentCancelDetail && currentCancelDetail.cancelType
            )
          }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">取消原因:</span>
          <span class="detail-value">{{
            (currentCancelDetail && currentCancelDetail.cancelReason) || "-"
          }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">取消时间:</span>
          <span class="detail-value">{{
            (currentCancelDetail && currentCancelDetail.cancelTime) || "-"
          }}</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDetailVisible = false">返回</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import meetingSignUpCarryPeopleApi from "@/api/meeting/meetingSignUpCarryPeople";
import meetingApi from "@/api/meeting/meeting";
import customerRegistrationPayApi from "@/api/cust/customerRegistrationPay";
import transportationVue from "./transportation.vue";

export default {
  components: {
    transportationVue
  },
  props: {
    rowItem: {
      type: Object,
      default: null
    },
    activeName: {
      type: [String, Number],
      default: "0"
    }
  },
  data() {
    return {
      form: null,
      participantsList: [],
      participantsLoading: false,
      meetingLoading: false,
      voucherDialogVisible: false,
      voucherList: [],
      cancelDetailVisible: false,
      currentCancelDetail: null
    };
  },
  computed: {
    /**
     * 将参会人列表按 parent-child 关系组织
     */
    groupedParticipants() {
      if (!this.participantsList || !Array.isArray(this.participantsList)) {
        return [];
      }
      const result = [];
      const processedIds = new Set();

      // 遍历列表，找出成人和其对应的儿童
      this.participantsList.forEach(item => {
        if (processedIds.has(item.id)) {
          return;
        }

        // 如果是成人（!isChild），创建父级对象
        if (!item.isChild) {
          const parent = { ...item, children: [] };

          // 查找该成人的所有儿童
          this.participantsList.forEach(childItem => {
            if (
              childItem.isChild &&
              (childItem.parentId === item.id ||
                childItem.signUpNo === item.signUpNo) &&
              !processedIds.has(childItem.id)
            ) {
              parent.children.push(childItem);
              processedIds.add(childItem.id);
            }
          });

          result.push(parent);
          processedIds.add(item.id);
        }
      });

      return result;
    },
    stateTxt() {
      let str = "";
      const activeName = +this.activeName;
      if (activeName === 99) {
        str = "未开始";
      } else if (activeName === 20) {
        str = "待参会";
      } else if (activeName === 30) {
        str = "已签到";
      } else if (activeName === 22) {
        str = "已完成";
      } else if (activeName === 40) {
        str = "已取消";
      } else if (activeName === 50) {
        str = "撤回报名";
      } else if (activeName === 10) {
        str = "待审核";
      }
      return str;
    }
  },
  created() {
    this.form = this.rowItem;
    this.loadMeetingDetail();
    this.loadParticipants();
  },
  methods: {
    /**
     * 加载会议详情
     */
    loadMeetingDetail() {
      if (!this.form || !this.form.meetingId) {
        return;
      }
      this.meetingLoading = true;
      meetingApi
        .fetchByIdTee(this.form.meetingId)
        .then(res => {
          if (res && res.data) {
            // 将会议详情合并到 form.meeting 中
            if (!this.form.meeting) {
              this.$set(this.form, "meeting", {});
            }
            Object.assign(this.form.meeting, res.data);
          }
        })
        .catch(error => {
          this.$message.error(error.msg || "获取会议详情失败");
        })
        .finally(() => {
          this.meetingLoading = false;
        });
    },
    /**
     * 加载参会人列表
     */
    loadParticipants() {
      if (!this.form || !this.form.signUpNo) {
        return;
      }
      this.participantsLoading = true;
      meetingSignUpCarryPeopleApi
        .fetchListTeev2({
          signNo: this.form.signUpNo,
          isGetTransportation: true
        })
        .then(res => {
          if (res && res.data) {
            this.participantsList = res.data || [];
          } else {
            this.participantsList = [];
          }
        })
        .catch(error => {
          this.$message.error(error.msg || "获取参会人列表失败");
          this.participantsList = [];
        })
        .finally(() => {
          this.participantsLoading = false;
        });
    },
    /**
     * 获取状态样式类
     */
    getStatusClass() {
      const activeName = +this.activeName;
      if (activeName === 99) {
        return "status-not-started";
      } else if (activeName === 20) {
        return "status-pending";
      } else if (activeName === 30) {
        return "status-signed-in";
      } else if (activeName === 22) {
        return "status-completed";
      } else if (activeName === 40) {
        return "status-cancelled";
      } else if (activeName === 50) {
        return "status-revoked";
      } else if (activeName === 10) {
        return "status-pending-review";
      }
      return "";
    },
    /**
     * 判断状态是否激活
     */
    isStatusActive(status) {
      const activeName = +this.activeName;
      // 状态顺序：10(待审核) -> 99(未开始) -> 20(待参会) -> 30(已签到) -> 22(已完成)
      // 注意：状态值不是按大小顺序排列的，需要按流程顺序判断
      if (status === 10) {
        // 待审核：只要 >= 10 就激活（已经过了待审核阶段）
        return activeName >= 10;
      } else if (status === 99) {
        // 未开始：需要 >= 99 或 === 20 或 === 30 或 === 22（已开始后保持激活）
        return (
          activeName >= 99 ||
          activeName === 20 ||
          activeName === 30 ||
          activeName === 22
        );
      } else if (status === 20) {
        // 待参会：需要 === 20 或 === 30 或 === 22（已参会后保持激活）
        return activeName === 20 || activeName === 30 || activeName === 22;
      } else if (status === 30) {
        // 已签到：需要 === 30 或 === 22（已签到后保持激活）
        return activeName === 30 || activeName === 22;
      } else if (status === 22) {
        // 已完成：需要 === 22
        return activeName === 22;
      }
      return false;
    },
    /**
     * 判断进度线是否激活
     * 进度线应该在前一个状态激活且当前状态也激活时才激活
     */
    isProgressLineActive(lineIndex) {
      const activeName = +this.activeName;
      // 进度线索引：0(待审核->未开始), 1(未开始->待参会), 2(待参会->已签到), 3(已签到->已完成)
      if (lineIndex === 0) {
        // 待审核 -> 未开始：需要 >= 99 或 === 20 或 === 30 或 === 22（已通过审核）
        return (
          activeName >= 99 ||
          activeName === 20 ||
          activeName === 30 ||
          activeName === 22
        );
      } else if (lineIndex === 1) {
        // 未开始 -> 待参会：需要 === 20 或 === 30 或 === 22（已开始参会）
        return activeName === 20 || activeName === 30 || activeName === 22;
      } else if (lineIndex === 2) {
        // 待参会 -> 已签到：需要 === 30 或 === 22（已签到）
        return activeName === 30 || activeName === 22;
      } else if (lineIndex === 3) {
        // 已签到 -> 已完成：需要 === 22（会议结束）
        return activeName === 22;
      }
      return false;
    },
    /**
     * 获取报名方式文本
     */
    getSourceText() {
      if (this.form.source === 10) {
        return "App报名";
      } else if (this.form.source === 20) {
        return "后台添加";
      } else if (this.form.source === 21) {
        return "导入";
      }
      return "-";
    },
     /**
     * 获取报名费用
     */
     getFeeText() {
      if(this.form.isItCarry){
        return "-";
      }
      if (this.form.paymentMethod===30) {
        return this.form.payVouchersFee;
      } else {
        return  this.form.Fee;
      }
      
    
    },
    /**
     * 获取入账类型文本
     */
    getGiftAccountTypeText() {
      if (this.form.giftAccountType === 1) {
        return "余额";
      } else if (this.form.giftAccountType === 2) {
        return "零售价";
      } else if (this.form.giftAccountType === 3) {
        return "赠送额度";
      }
      return "";
    },
    /**
     * 获取区域文本
     */
    getUserRegionText() {
      if (this.form.userRegion) {
        return this.form.userRegion;
      }
      if (this.form.userRegions && typeof this.form.userRegions === "object") {
        // 从对象中提取省市区，按代码长度排序（省2位，市4位，区6位）
        const entries = Object.entries(this.form.userRegions);
        // 按键的长度排序，确保顺序是：省(2位) -> 市(4位) -> 区(6位)
        entries.sort((a, b) => {
          const keyA = String(a[0]).length;
          const keyB = String(b[0]).length;
          return keyA - keyB;
        });
        const regions = entries.map(entry => entry[1]);
        if (regions.length > 0) {
          return regions.join("");
        }
      }
      return "";
    },
    /**
     * 获取成人数量
     */
    getAdultCount() {
      return this.participantsList.filter(item => !item.isChild).length;
    },
    /**
     * 获取儿童数量
     */
    getChildCount() {
      return this.participantsList.filter(item => item.isChild).length;
    },
    /**
     * 手机号脱敏处理
     */
    maskMobile(mobile) {
      if (!mobile) return "-";
      if (mobile.length === 11) {
        return mobile.substring(0, 3) + "****" + mobile.substring(7);
      } else if (mobile.length > 11) {
        const phonePart = mobile.substring(0, 11);
        const extraPart = mobile.substring(11);
        return (
          phonePart.substring(0, 3) +
          "****" +
          phonePart.substring(7) +
          extraPart
        );
      }
      return mobile;
    },
    /**
     * 身份证脱敏处理
     */
    maskIdCard(idCard) {
      if (!idCard) return "-";
      if (idCard.length > 8) {
        return (
          idCard.substring(0, 4) +
          "***********" +
          idCard.substring(idCard.length - 4)
        );
      }
      return idCard;
    },
    /**
     * 判断是否有凭证
     */
    hasVoucher() {
      return (
        (this.form.payVouchersList && this.form.payVouchersList.length > 0) ||
        (this.form.payVoucherList && this.form.payVoucherList.length > 0) ||
        (this.form.payVouchers && this.form.payVouchers.length > 0) ||
        (this.form.applyVouchersUrl &&
          this.form.applyVouchersUrl.trim().length > 0)
      );
    },
    /**
     * 查看凭证
     */
    handleViewVoucher() {
      // 如果是线下报名（paymentMethod === 30），调用接口查询凭证
      if (this.form.paymentMethod === 30) {
        // 根据会议状态判断 state 参数：待审核(activeName === 10) 传 0，其他状态传 1
        const state = +this.activeName === 10 ? 0 : 1;
        const params = {
          dataType: 50,
          registrationId: this.form.id, // 主键id就是会议报名id
          state: state
        };
        
        customerRegistrationPayApi
          .fetchList(params)
          .then(res => {
            if (res && res.code === '0' && res.data) {
              // 处理返回的数据，可能是数组或对象
              if (Array.isArray(res.data)) {
                this.voucherList = res.data;
              } else if (res.data.list && Array.isArray(res.data.list)) {
                this.voucherList = res.data.list;
              } else {
                this.voucherList = [];
              }
            } else {
              this.voucherList = [];
            }
            this.voucherDialogVisible = true;
          })
          .catch(error => {
            this.$message.error(error.msg || "获取凭证失败");
            this.voucherList = [];
            this.voucherDialogVisible = true;
          });
        return;
      }
      
      // 非线下报名，使用原有逻辑
      // 优先使用 payVouchersList
      if (this.form.payVouchersList && this.form.payVouchersList.length > 0) {
        this.voucherList = this.form.payVouchersList;
      } else if (
        this.form.payVoucherList &&
        this.form.payVoucherList.length > 0
      ) {
        this.voucherList = this.form.payVoucherList;
      } else if (this.form.payVouchers && this.form.payVouchers.length > 0) {
        this.voucherList = this.form.payVouchers.map(img => ({ payImg: img }));
      } else {
        this.voucherList = [];
      }
      this.voucherDialogVisible = true;
    },
    /**
     * 查看交通信息
     */
    handleViewTransportation(row) {
      // 直接设置 signNo 并打开交通信息详情弹窗，跳过列表弹窗
      const transportationVue = this.$refs.transportationVue;
      transportationVue.signNo = row.signUpNo || this.form.signUpNo;
      transportationVue.handleViewTransportation(row);
    },
    /**
     * 查看取消明细
     */
    handleViewCancelDetail(participant) {
      this.currentCancelDetail = {
        cancelType: participant.cancelType,
        cancelReason: participant.cancelReason,
        cancelTime: participant.cancelTime
      };
      this.cancelDetailVisible = true;
    },
    /**
     * 获取取消类型文本
     */
    getCancelTypeText(cancelType) {
      if (cancelType === 20) {
        return "报名订单取消";
      } else if (cancelType === 30) {
        return "会议取消";
      }
      return "-";
    },
    handleBack() {
      this.$emit("handleShow", "", 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.app-container {
  padding: 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 84px);
}

// 通用样式
.section-box {
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  position: relative;
}

// 返回按钮
.back-button {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 10;
  padding: 6px 5px;
  background-color: #1596cd;
  color: #ffffff;
  border-radius: 0 16px 0 16px;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.3s;
  white-space: nowrap;

  &:hover {
    background-color: #66b1ff;
  }

  &:active {
    background-color: #3a8ee6;
  }
}

// 头部信息
.record-info {
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 10px;

  // 屏幕宽度小于1400px时，垂直排列
  @media (max-width: 1399px) {
    flex-direction: column;
  }
}

.header-section {
  padding: 20px;
  flex: 2;

  // 屏幕宽度小于1400px时，占满宽度
  @media (max-width: 1399px) {
    flex: 1;
    width: 100%;
  }
  .order-info {
    display: flex;
    gap: 50px;
    color: #000000;
    font-size: 14px;

    .order-status {
      font-size: 16px;
      color: #1596cd;
    }

    .order-id {
      margin-bottom: 8px;
      display: flex;
      align-items: center;

      i {
        margin-left: 6px;
        color: #7d7d7d;
        font-size: 20px;
      }
    }
  }
  .header-top {
    margin-bottom: 16px;

    .status-badge {
      display: inline-block;
      padding: 4px 12px;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 500;
      white-space: nowrap;

      &.status-not-started {
        background: #409eff;
        color: #fff;
      }

      &.status-pending {
        background: #e6a23c;
        color: #fff;
      }

      &.status-signed-in {
        background: #67c23a;
        color: #fff;
      }

      &.status-completed {
        background: #909399;
        color: #fff;
      }

      &.status-cancelled {
        background: #f56c6c;
        color: #fff;
      }

      &.status-revoked {
        background: #909399;
        color: #fff;
      }

      &.status-pending-review {
        background: #e6a23c;
        color: #fff;
      }
    }
  }

  .registrant-title {
    color: #000000;
    font-size: 16px;
    font-weight: 500;
    padding: 10px 0;
  }
  .registrant-info {
    padding-top: 10px;
    .registrant-name {
      font-size: 16px;
      color: #000000;
      margin-bottom: 8px;
      .level-name {
        font-size: 14px;
        color: #1596cd;
        margin-left: 10px;
        padding: 1px 5px;
        border-radius: 24px;
        border: 1px solid #1596cd;
        background-color: #e1f1f9;
      }
    }

    .registrant-details {
      font-size: 14px;
      color: #666;
      display: flex;
      line-height: 40px;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;

      span {
        display: block;
      }
    }
  }
}

// 进度条
.progress-section {
  display: flex;
  flex: 3;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px;
  background: #ffffff;
  border-radius: 16px;
  position: relative;

  // 屏幕宽度小于1400px时，占满宽度
  @media (max-width: 1399px) {
    flex: 1;
    width: 100%;
  }

  .progress-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    text-align: center;
    position: relative;
    z-index: 2;

    .progress-dot {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: #ddd;
      margin-bottom: 8px;
      transition: all 0.3s;
      position: relative;
      z-index: 3;
    }

    span {
      font-size: 16px;
      color: #6c6c6c;
      margin-bottom: 10px;
    }

    .progress-time {
      font-size: 12px;
      color: #999;
      line-height: 1.6;

      div {
        margin-bottom: 4px;
      }
    }

    &.active {
      .progress-dot {
        background: #5dbde7;
        box-shadow: 0 0 0 4px rgba(93, 189, 231, 0.2);
      }

      span {
        color: #5dbde7;
        font-weight: 500;
      }
    }
  }

  .progress-line {
    position: absolute;
    top: 26px; // padding-top(20px) + 进度点高度的一半(6px) - 进度线高度的一半(1px)
    height: 2px;
    background: #ddd;
    transition: all 0.3s;
    z-index: 1;

    &.progress-line-0 {
      // 连接第1个进度点(10%)和第2个进度点(30%)，从右边缘到左边缘
      left: calc(10% + 10px);
      right: calc(70% + 8px);
    }

    &.progress-line-1 {
      // 连接第2个进度点(30%)和第3个进度点(50%)，从右边缘到左边缘
      left: calc(30% + 8px);
      right: calc(50% + 8px);
    }

    &.progress-line-2 {
      // 连接第3个进度点(50%)和第4个进度点(70%)，从右边缘到左边缘
      left: calc(50% + 8px);
      right: calc(30% + 8px);
    }

    &.progress-line-3 {
      // 连接第4个进度点(70%)和第5个进度点(90%)，从右边缘到左边缘
      left: calc(70% + 8px);
      right: calc(10% + 10px);
    }

    &.active {
      background: #5dbde7;
    }
  }
}

// 会议信息
.meeting-section {
  .section-header {
    border-bottom: 1px solid #ebeef5;
    padding-bottom: 12px;
    margin-bottom: 20px;
  }

  .meeting-header {
    display: flex;
    gap: 18px;
    align-items: flex-start;

    .main-image {
      width: 212px;
      height: 150px;
      border-radius: 8px;
      object-fit: cover;
      flex-shrink: 0;
    }

    .meeting-content {
      flex: 1;
      min-width: 0;

      .meeting-title-wrapper {
        margin-bottom: 16px;

        .meeting-title-text {
          margin: 0;
          font-size: 16px;
          font-weight: 600;
          color: #000000;
          line-height: 1.5;
          display: inline-block;
        }

        .meeting-type-badge {
          display: inline-block;
          padding: 2px 8px;
          font-size: 12px;
          color: #666666;
          background: #f5f7fa;
          border: 1px solid #e4e7ed;
          border-radius: 4px;
          white-space: nowrap;
          margin-left: 8px;
          vertical-align: middle;
        }
      }

      .meeting-meta {
        .meta-item {
          margin-bottom: 8px;
          font-size: 13px;
          color: #6c6c6c;
          line-height: 20px;

          .meta-label {
            color: #6c6c6c;
            margin-right: 4px;
          }

          .meta-value {
            color: #333333;
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}

// 参会人信息
.participants-section {
  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .participants-summary {
      font-size: 16px;
      color: #e73f3f;
    }
  }

  .participants-table {
    border: 1px solid #ebeef5;
    border-radius: 8px;
    overflow: hidden;

    .table-header {
      display: flex;
      background: #f8f9fa;
      border-bottom: 1px solid #ebeef5;

      .header-cell {
        padding: 12px;
        font-size: 14px;
        font-weight: 600;
        color: #333;
        text-align: center;
        border-right: 1px solid #ebeef5;

        &:last-child {
          border-right: none;
        }
      }
    }

    .table-body {
      .table-row {
        display: flex;
        background: #fff;
        border-bottom: 1px solid #ebeef5;

        &:last-child {
          border-bottom: none;
        }

        &:nth-child(even) {
          background-color: #fafafa;
        }

        .table-cell {
          padding: 16px 12px;
          font-size: 14px;
          color: #333;
          text-align: left;
          border-right: 1px solid #ebeef5;
          display: flex;
          align-items: center;

          &:last-child {
            border-right: none;
          }
        }
      }
    }
  }

  .participant-info {
    letter-spacing: 1px;
    .participant-name {
      font-size: 15px;
      color: #7c7777;
      margin-bottom: 6px;

      .relationship {
        color: #666;
        font-weight: normal;
      }

      .gender {
        margin-left: 8px;
        color: #666;
      }
    }

    .participant-id {
      font-size: 12px;
      color: #6c6c6c;
      margin-bottom: 4px;

      .age-tag {
        color: #999;
        margin-left: 4px;
      }
    }

    .participant-mobile {
      font-size: 12px;
      color: #6c6c6c;
    }
  }

  .accommodation-info {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .accommodation-item {
      font-size: 12px;
      color: #666;
    }
  }

  .auth-status {
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;

    &.authenticated {
      background: #f0f9ff;
      color: #5dbde7;
    }

    &.not-authenticated {
      background: #fef0f0;
      color: #f56c6c;
    }

    &.no-auth-required {
      background: #f5f7fa;
      color: #909399;
    }
  }

  .empty-data {
    padding: 40px;
    text-align: center;
    color: #999;
  }
}

// 支付方式行样式
.payment-method-row {
  display: flex;
  align-items: center;
  justify-content: center;
}

// 查看凭证链接样式
.view-voucher-link {
  margin-left: 8px;
  color: #1596cd;
  font-size: 12px;
}

.voucher-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

// 取消明细弹窗样式
.cancel-detail-content {
  .detail-item {
    margin-bottom: 16px;
    font-size: 14px;
    line-height: 1.5;

    .detail-label {
      color: #666;
      margin-right: 8px;
    }

    .detail-value {
      color: #333;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
